module.exports = __webpack_public_path__ + "static/media/pr-6.f5d9ab9b.jpg";